import formatPriceBandPayload from './formatPriceBandPayload';
export default formatPriceBandPayload;
